import { EmailSealIcon } from './EmailSealIcon';

/**
 * author: Michael Irigoyen
 * id 9671987F-A6B4-4934-90B1-E2C590CEB1B9
 * name email-seal
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-seal.svg
 * tags
 */
export const EmailCertifiedIcon = EmailSealIcon;
export default EmailCertifiedIcon